import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6b1bf22f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters-panel" }
const _hoisted_2 = { class: "filters-header-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filters-header-title" }, "Фильтры", -1))
const _hoisted_4 = {
  key: 0,
  class: "filters-chips-inline"
}
const _hoisted_5 = {
  key: 0,
  class: "chips-container"
}
const _hoisted_6 = { class: "chip-label" }
const _hoisted_7 = { class: "chip-value" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "no-filters-text"
}
const _hoisted_10 = {
  key: 0,
  class: "filters-content"
}
const _hoisted_11 = { class: "filters-row" }
const _hoisted_12 = { class: "filter-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "filter-label" }, "Бренд", -1))
const _hoisted_14 = { class: "filter-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "filter-label" }, "Сегмент", -1))
const _hoisted_16 = { class: "filter-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "filter-label" }, "Площадка", -1))
const _hoisted_18 = { class: "filter-field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "filter-label" }, "Кабинет", -1))
const _hoisted_20 = { class: "filters-row" }
const _hoisted_21 = { class: "filter-field date-range-field" }
const _hoisted_22 = { class: "filter-field" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "filter-label" }, "Статус", -1))
const _hoisted_24 = { class: "filter-actions" }

import { ref, watch, onMounted, computed } from "vue";
import MultiSelect from "primevue/multiselect";
import Button from "primevue/button";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";
import DateRangeSelect, {
  type DateRange,
} from "@/shared/forms/DateRangeSelect.vue";
import { useCampaignsDictionariesStore } from "@/store/dictionaries/campaigns";
import { useBrandsStore } from "@/store/catalog_data/brands";
import { useSegmentsDictionaryStore } from "@/store/segments/segments_dictionary";
import { useAdsCabinetsDictionariesStore } from "@/store/catalog_data/ads_cabinets";
import { usePlatformsDictionaryStore } from "@/store/catalog_data/platforms";
import {
  formatDateToYYYYMMDD,
  formatDateToDDMMYYYY,
} from "@/services/utils/DateParser";
import type { StatisticsFilter } from "@/store/expenses/statistics";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsFilters',
  props: {
    appliedFilter: {}
  },
  emits: ["apply", "reset", "removeFilter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const campaignsDictionariesStore = useCampaignsDictionariesStore();
const brandsStore = useBrandsStore();
const segmentsStore = useSegmentsDictionaryStore();
const adsCabinetsStore = useAdsCabinetsDictionariesStore();
const platformsStore = usePlatformsDictionaryStore();

const isCollapsed = ref(true);

const initialFilter: StatisticsFilter = {
  brand: [] as string[],
  segment: [] as number[],
  ads_cabinet: [] as number[],
  date: null as DateRange | null,
  state: [] as number[],
  platform: [] as string[],
};

const filter = ref<StatisticsFilter>({ ...initialFilter });

const toggleCollapsed = () => {
  isCollapsed.value = !isCollapsed.value;
};

const updateFilter = (key: string, value: any) => {
  (filter.value as any)[key] = value;
};

const applyFilter = () => {
  emit("apply", { ...filter.value });
};

const resetFilter = () => {
  filter.value = { ...initialFilter };
  emit("reset");
};

const removeFilter = (chip: {
  key: string;
  value: string | number;
  originalValue: string | number;
}) => {
  const applied = props.appliedFilter || filter.value;
  const updatedFilter = { ...applied };

  if (chip.key === "brand") {
    updatedFilter.brand = updatedFilter.brand.filter(
      (b) => b !== chip.originalValue
    );
  } else if (chip.key === "segment") {
    updatedFilter.segment = updatedFilter.segment.filter(
      (s) => s !== chip.originalValue
    );
  } else if (chip.key === "ads_cabinet") {
    updatedFilter.ads_cabinet = updatedFilter.ads_cabinet.filter(
      (c) => c !== chip.originalValue
    );
  } else if (chip.key === "state") {
    updatedFilter.state = updatedFilter.state.filter(
      (s) => s !== chip.originalValue
    );
  } else if (chip.key === "platform") {
    updatedFilter.platform = updatedFilter.platform.filter(
      (p) => p !== chip.originalValue
    );
  } else if (chip.key === "date") {
    updatedFilter.date = null;
  }

  filter.value = updatedFilter;
  emit("apply", updatedFilter);
};

const hasActiveFilters = computed(() => {
  const applied = props.appliedFilter || filter.value;
  return (
    (applied.brand && applied.brand.length > 0) ||
    (applied.segment && applied.segment.length > 0) ||
    (applied.ads_cabinet && applied.ads_cabinet.length > 0) ||
    (applied.state && applied.state.length > 0) ||
    (applied.platform && applied.platform.length > 0) ||
    (applied.date && (applied.date.start_date || applied.date.end_date))
  );
});

const activeFilterChips = computed(() => {
  const applied = props.appliedFilter || filter.value;
  const chips: Array<{
    key: string;
    label: string;
    value: string | number;
    originalValue: string | number;
  }> = [];

  if (applied.brand && applied.brand.length > 0) {
    applied.brand.forEach((brandPk) => {
      const brand = brandsStore.itemList.find((b) => b.brand_pk === brandPk);
      chips.push({
        key: "brand",
        label: "Бренд",
        value: brand ? brand.brand_name : brandPk,
        originalValue: brandPk,
      });
    });
  }

  if (applied.segment && applied.segment.length > 0) {
    applied.segment.forEach((segmentId) => {
      const segment = segmentsStore.itemList.find((s) => s.id === segmentId);
      chips.push({
        key: "segment",
        label: "Сегмент",
        value: segment ? segment.name : `ID: ${segmentId}`,
        originalValue: segmentId,
      });
    });
  }

  if (applied.ads_cabinet && applied.ads_cabinet.length > 0) {
    applied.ads_cabinet.forEach((cabinetId) => {
      const cabinet = adsCabinetsStore.itemsWithName.find(
        (c) => c.id === cabinetId
      );
      chips.push({
        key: "ads_cabinet",
        label: "Кабинет",
        value: cabinet ? cabinet.name : `ID: ${cabinetId}`,
        originalValue: cabinetId,
      });
    });
  }

  if (applied.platform && applied.platform.length > 0) {
    applied.platform.forEach((platformSlug) => {
      const platform = platformsStore.itemList.find(
        (p) => p.slug === platformSlug
      );
      chips.push({
        key: "platform",
        label: "Площадка",
        value: platform ? platform.name : platformSlug,
        originalValue: platformSlug,
      });
    });
  }

  if (applied.state && applied.state.length > 0) {
    applied.state.forEach((stateId) => {
      const state = campaignsDictionariesStore.segmentsStatesForStatistics.find(
        (s) => s.id === stateId
      );
      chips.push({
        key: "state",
        label: "Статус",
        value: state ? state.display_name : `ID: ${stateId}`,
        originalValue: stateId,
      });
    });
  }

  if (applied.date && (applied.date.start_date || applied.date.end_date)) {
    const startDate = applied.date.start_date
      ? formatDateToDDMMYYYY(
          applied.date.start_date instanceof Date
            ? applied.date.start_date
            : new Date(applied.date.start_date)
        )
      : "";
    const endDate = applied.date.end_date
      ? formatDateToDDMMYYYY(
          applied.date.end_date instanceof Date
            ? applied.date.end_date
            : new Date(applied.date.end_date)
        )
      : "";
    chips.push({
      key: "date",
      label: "Дата",
      value:
        startDate && endDate
          ? `${startDate} - ${endDate}`
          : startDate || endDate,
      originalValue: "date",
    });
  }

  return chips;
});

watch(
  () => props.appliedFilter,
  (newFilter) => {
    if (newFilter) {
      filter.value = { ...newFilter };
    }
  },
  { deep: true, immediate: true }
);

onMounted(async () => {
  if (campaignsDictionariesStore.segmentsStates.length === 0) {
    await campaignsDictionariesStore.getSegmentsStates();
  }

  const applied = props.appliedFilter;
  if (applied) {
    if (
      applied.brand &&
      applied.brand.length > 0 &&
      brandsStore.itemList.length === 0
    ) {
      if (!brandsStore.isLoadingInitial) {
        await brandsStore.getItems("", applied.brand, true, true, 0, 100, true);
      }
    }

    if (
      applied.segment &&
      applied.segment.length > 0 &&
      segmentsStore.itemList.length === 0
    ) {
      if (!segmentsStore.isLoadingInitial) {
        await segmentsStore.getItems(
          "",
          applied.segment.map(String),
          true,
          true,
          0,
          100,
          true
        );
      }
    }
    if (
      applied.ads_cabinet &&
      applied.ads_cabinet.length > 0 &&
      adsCabinetsStore.itemList.length === 0
    ) {
      if (!adsCabinetsStore.isLoadingInitial) {
        await adsCabinetsStore.getItems(
          "",
          applied.ads_cabinet.map(String),
          true,
          true,
          0,
          100,
          true
        );
      }
    }

    if (
      applied.platform &&
      applied.platform.length > 0 &&
      platformsStore.itemList.length === 0
    ) {
      if (!platformsStore.isLoadingInitial) {
        await platformsStore.getItems(
          "",
          applied.platform,
          true,
          true,
          0,
          100,
          true
        );
      }
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "filters-header",
      onClick: toggleCollapsed
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (isCollapsed.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (hasActiveFilters.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeFilterChips.value, (chip) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: chip.key,
                        class: "filter-chip"
                      }, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(chip.label) + ":", 1),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(chip.value), 1),
                        _createElementVNode("i", {
                          class: "pi pi-times chip-remove",
                          onClick: _withModifiers(($event: any) => (removeFilter(chip)), ["stop"])
                        }, null, 8, _hoisted_8)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, "Фильтры не применены"))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("i", {
        class: _normalizeClass([
          'pi',
          isCollapsed.value ? 'pi-chevron-down' : 'pi-chevron-up',
          'filters-header-icon',
        ])
      }, null, 2)
    ]),
    (!isCollapsed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(CatalogDataBaseInput, {
                useIdOnly: true,
                selectType: "brand",
                isSegmentSetted: false,
                modelValue: filter.value.brand,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => updateFilter('brand', $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(CatalogDataBaseInput, {
                useIdOnly: true,
                selectType: "segment",
                isSegmentSetted: false,
                modelValue: filter.value.segment,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => updateFilter('segment', $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(CatalogDataBaseInput, {
                useIdOnly: true,
                selectType: "platform",
                isSegmentSetted: false,
                modelValue: filter.value.platform,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => updateFilter('platform', $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(CatalogDataBaseInput, {
                useIdOnly: true,
                selectType: "ads_cabinet",
                isSegmentSetted: false,
                modelValue: filter.value.ads_cabinet,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => updateFilter('ads_cabinet', $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(DateRangeSelect, {
                modelValue: filter.value.date,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => updateFilter('date', $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_unref(MultiSelect), {
                modelValue: filter.value.state,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filter.value.state) = $event)),
                optionValue: "id",
                options: _unref(campaignsDictionariesStore).segmentsStatesForStatistics,
                optionLabel: "display_name",
                placeholder: "Выберите значение"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_unref(Button), {
                label: "Применить",
                class: "apply-button",
                onClick: applyFilter
              }),
              _createVNode(_unref(Button), {
                label: "Сбросить",
                severity: "secondary",
                outlined: "",
                class: "reset-button",
                onClick: resetFilter
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})